import React from "react";
import { Switch, Route} from "react-router-dom";
import Contact from "./contact";
import Create from "./Createpost";
import Main from "./Dispaly";
import Login from "./Login";


function App() {
  return (
      <Switch>
      <Route exact path="/login" component={Login}/>
      <Route exact path="/add" component={Create}/>
      <Route exact path="/"  component={Main}/>
       <Route exact path="/contact" component={Contact}/>
      </Switch>
  );
}

export default App;
